import images from 'assets/images/images'
import React from 'react'
import { useDispatch } from 'react-redux'
import { authModalOpen } from 'redux/features/general/generalSlice';

const AllModal = ({authModalContent}) => {
   const dispatch = useDispatch();
  return (
    <div className='allModal' >
       <div className='allModal-container'>
        <div className='allModal-close'>
           <img src={images.close} alt="" onClick={() => dispatch(authModalOpen(false))}/>
        </div>
        {authModalContent}
       </div>
    </div>
  )
}

export default AllModal